"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Select } from "@justhome/react-ui";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { HTMLAttributes } from "react";
import { periods } from "../../lib/constants";
import { Period } from "../../lib/types";
interface ClientPeriodSelectProps {
  value: Period;
}
interface PeriodSelectProps extends ClientPeriodSelectProps, Omit<HTMLAttributes<HTMLDivElement>, "onChange"> {
  onChange: (p: Period) => void;
}
const PeriodSelect = t0 => {
  const $ = _c(18);
  let onChange;
  let props;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      onChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onChange;
    $[2] = props;
    $[3] = value;
  } else {
    onChange = $[1];
    props = $[2];
    value = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="mb-xs text-body-2 block">Betrachtungszeitraum</p>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== onChange || $[6] !== value) {
    t2 = periods.map(p => <Button onClick={() => onChange(p.id)} size="sm" key={p.id} variant={value === p.id ? "primary" : "outline_primary"}>{p.label}</Button>);
    $[5] = onChange;
    $[6] = value;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <div className="hidden m:flex gap-2xs">{t2}</div>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = periods.map(_temp);
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== onChange || $[12] !== value) {
    t5 = <div className="flex m:hidden"><Select value={value} onChange={onChange} size="sm" label="" className="max-w-full w-[200px]">{t4}</Select></div>;
    $[11] = onChange;
    $[12] = value;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== props || $[15] !== t3 || $[16] !== t5) {
    t6 = <div {...props}>{t1}{t3}{t5}</div>;
    $[14] = props;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export const ClientPeriodSelect = t0 => {
  const $ = _c(7);
  const {
    value
  } = t0;
  const params = useSearchParams();
  const pathname = usePathname();
  const {
    replace
  } = useRouter();
  let t1;
  if ($[0] !== params || $[1] !== pathname || $[2] !== replace) {
    t1 = newValue => {
      const newParams = new URLSearchParams(params.toString());
      if (newValue) {
        newParams.set("period", newValue.toString());
      } else {
        newParams.delete("period");
      }
      replace(`${pathname}?${newParams.toString()}`);
    };
    $[0] = params;
    $[1] = pathname;
    $[2] = replace;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handlePeriodChange = t1;
  let t2;
  if ($[4] !== handlePeriodChange || $[5] !== value) {
    t2 = <PeriodSelect value={value} onChange={handlePeriodChange} />;
    $[4] = handlePeriodChange;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default PeriodSelect;
function _temp(p_0) {
  return <Select.Option key={p_0.id} value={p_0.id}>{p_0.label}</Select.Option>;
}